import React from 'react'
import BlogHero from '../Blogs/BlogHero'
import BlogSection from '../Blogs/Blogsection'
import Footer from '../Footer/Footer'

function Blogs() {
    return (
        <div>
          <BlogHero/>
          <BlogSection/>
          <Footer/>

        </div>
    )
}

export default Blogs
